export default __webpack_public_path__ + "static/media/T09A.c0279dc2.png";